import appService from '../js/appservice/index'
import funcs from '../js/helpers/misc'
import { getErrorMessage } from '../js/helpers/storehelper'

const state = {
  currentReport: {},
  reports: []
}

const getters = {
  currentReport: state => state.currentReport,
  reports: state => state.reports
}

const actions = {
  getAllReports(context) {
    return new Promise((resolve, reject) => {
      appService.expertreports
        .getAllReports()
        .then(data => {
          context.commit('getAllReports', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getReport(context, reportInfo) {
    return new Promise((resolve, reject) => {
      appService.expertreports
        .getReport(reportInfo.reportId)
        .then(data => {
          context.commit('selectCurrentReport', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getReportDetails(context, reportInfo) {
    return new Promise((resolve, reject) => {
      appService.expertreports
        .getReportDetails(reportInfo.reportId)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  saveReportDetails(context, data) {
    return new Promise((resolve, reject) => {
      if (data.id) {
        appService.expertreports
          .updateReport(data)
          .then(data => {
            context.commit('updateReport', data)
            resolve()
          })
          .catch(error => {
            reject(error.data)
          })
      } else {
        appService.expertreports
          .addReport(data)
          .then(data => {
            context.commit('addReport', data)
            resolve()
          })
          .catch(error => {
            reject(error.data)
          })
      }
    })
  },
  deleteReport(context, report) {
    return new Promise((resolve, reject) => {
      appService.expertreports
        .deleteReport(report.id)
        .then(data => {
          context.commit('deleteReport', report)
          resolve()
        })
        .catch(error => {
          reject(error.data)
        })
    })
  },
  deleteTranslation(context, translation) {
    return new Promise((resolve, reject) => {
      if (translation.id) {
        appService.expertreports
          .deleteTranslation(state.currentReport.id, translation.id)
          .then(data => {
            context.commit('deleteTranslation', translation)
            resolve()
          })
          .catch(error => {
            reject(error.data)
          })
      } else {
        context.commit('deleteTranslation', translation)
        resolve()
      }
    })
  },
  selectCurrentReport(context, report) {
    context.commit('selectCurrentReport', report)
  }
}

const mutations = {
  getReport(state, data) {
    state.currentReport = data
  },
  getAllReports(state, data) {
    state.reports = data
  },
  addReport(state, data) {
    state.currentReport = data
    // state.reportList.push(data)
    state.reports.push(data)
  },
  updateReport(state, data) {
    state.currentReport = data
  },
  deleteReport(state, data) {
    var index = funcs.getIndexInCollection('id', data.id, state.reports)
    if (index !== -1) {
      state.reports.splice(index, 1)
    }
  },
  selectCurrentReport(state, data) {
    state.currentReport = data
  },
  deleteTranslation(state, data) {
    var index = funcs.getIndexInCollection(
      'languageId',
      data.languageId,
      state.currentReport.translations
    )
    if (index !== -1) {
      state.currentReport.translations.splice(index, 1)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
